'use strict';

export function getBrowser() {
  const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
  const userAgent = window.navigator.userAgent;

  const getFirstMatch = regexp => {
    const match = userAgent.match(regexp);
    return (match && match.length > 0 && match[1]) || '';
  };

  const getSecondMatch = regexp => {
    const match = userAgent.match(regexp);
    return (match && match.length > 1 && match[2]) || '';
  };

  const browserNames = [
    {
      name: 'Opera',
      regex: /opr\/|opios/i,
      version: getFirstMatch(/(?:opr|opios)[\s/](\S+)/i) || getFirstMatch(commonVersionIdentifier)
    },
    {
      name: 'Samsung Internet for Android',
      regex: /SamsungBrowser/i,
      version: getFirstMatch(commonVersionIdentifier) || getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i)
    },
    {
      name: 'Internet Explorer',
      regex: /msie|trident/i,
      version: getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i)
    },
    { name: 'Microsoft Edge', regex: /\sedg\//i, version: getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i) },
    {
      name: 'Microsoft Edge',
      regex: /edg([ea]|ios)/i,
      version: getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i)
    },
    {
      name: 'Firefox',
      regex: /firefox|iceweasel/i,
      version: getFirstMatch(/(?:firefox|iceweasel)[\s/](\d+(\.?_?\d+)+)/i)
    },
    {
      name: 'Chromium',
      regex: /chromium/i,
      version: getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i) || getFirstMatch(commonVersionIdentifier)
    },
    {
      name: 'Chrome',
      regex: /chrome|crios|crmo/i,
      version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i)
    },
    { name: 'Safari', regex: /safari|applewebkit/i, version: getFirstMatch(commonVersionIdentifier) }
  ];

  return browserNames.find(browser => browser.regex.test(userAgent));
}

export function getPlatform() {
  return {
    name: window.navigator.platform,
    version: '',
    versionName: ''
  };
}
